// „Отказ" в питането „масата има резервация" при БЪРЗОТО отваряне
// (`Ordering.handleNewTable`, номерът от `GET /bills/next-table-name`): вместо
// само да спре, Маркиране предлага следващия свободен номер БЕЗ резервация.
// Чиста логика без React и без нов BE endpoint (тестове:
// nextFreeTableName.test.ts) — проверката на всяко име е `checkTableName`.

/** Колко номера след резервирания се пробват, преди да се откажем. */
export const FREE_TABLE_ATTEMPTS = 20;

/**
 * Отговорът на `check-table-name` за едно име. `reservation` може да ЛИПСВА
 * (каса/по-стар облак без полето) — тогава името се брои за свободно.
 */
export interface TableNameProbeResult {
  exists: boolean;
  reservation?: unknown;
}

export type TableNameProbe = (name: string) => Promise<TableNameProbeResult>;

/**
 * Кандидатите след резервираното име: при числово име — число+1, +2, … (общо
 * `attempts`); нечислово име („VIP", „12а") няма следващ номер → празен списък.
 */
export const freeTableCandidates = (
  reservedName: string,
  attempts = FREE_TABLE_ATTEMPTS,
): string[] => {
  const trimmed = reservedName.trim();
  const n = Number(trimmed);
  if (trimmed === "" || !Number.isInteger(n) || n < 0) return [];
  return Array.from({ length: attempts }, (_, i) => String(n + 1 + i));
};

/**
 * Първото име след `reservedName`, което не съществува и няма резервация;
 * `null` — нечислово име, нищо свободно в `attempts` опита или пропаднала
 * проверка (облакът не отговаря — тогава и следващите няма да минат, а
 * непроверен номер не се предлага).
 */
export const findFreeTableName = async (
  reservedName: string,
  probe: TableNameProbe,
  attempts = FREE_TABLE_ATTEMPTS,
): Promise<string | null> => {
  for (const name of freeTableCandidates(reservedName, attempts)) {
    let check: TableNameProbeResult;
    try {
      check = await probe(name);
    } catch {
      return null;
    }
    if (!check.exists && check.reservation == null) return name;
  }
  return null;
};
